import type { IDataState, TApiUrlName } from './interfaces'

export const responseAccumulator: Partial<Record<TApiUrlName, (data: unknown, state: IDataState) => unknown>> = {}
